import classnames from 'classnames'

import Button from '@components/Button'
import EditBookingPriceBreakdown from '@components/EditBookingPriceBreakdown'
import { PriceToPay } from '@components/EditBookingPriceBreakdown/PriceToPay'

import { currencyFromSymbol } from 'shared/currency-utilities'

import { RateCurrency } from '../../utilities'
import styles from './styles.module.scss'

const FooterSection = ({
    rate,
    total,
    loading,
    disabled,
    setPriceBreakdownModalOpen,
    rateCurrencySymbol,
    editedReservationNewTotalPrice,
    amendmentFee,
    oldPrice,
    newPrice,
    showPriceDifference,
}) => (
    <div className={styles.footerSection}>
        <Button
            onClick={() => setPriceBreakdownModalOpen(true)}
            className="mb-2"
            type="button"
            size="small"
            btnStyle="link">
            <T>price.breakdown</T>
        </Button>
        {showPriceDifference ? (
            <EditBookingPriceBreakdown
                rate={rate}
                rateCurrencySymbol={rateCurrencySymbol}
                oldPrice={oldPrice}
                newPrice={newPrice}
                editedReservationNewTotalPrice={editedReservationNewTotalPrice}
                amendmentFee={amendmentFee}
            />
        ) : (
            <PriceToPay
                rate={rate}
                label={<T>subscripition.purchase.pay.label.total</T>}
                total={total}
                rateCurrencySymbol={rateCurrencySymbol}
            />
        )}
        <div className={(classnames('d-sm-flex justify-content-between align-items-center'), styles.buyBtnContainer)}>
            <Button isLoading={loading} btnStyle="primary" type="submit" disabled={disabled}>
                <T>booking.btn.buy.now</T>
            </Button>
        </div>
    </div>
)

export default FooterSection
